module.exports = __webpack_public_path__ + "img/w60b.8551b342.jpg";